import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import {
  Box,
  IconButton,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";

interface Props {
  activeTab: "partner" | "public";
  partnerShipmentCount: number;
  publicShipmentCount: number;
  onTabChange: (tab: "partner" | "public") => void;
  onRefreshClick?: VoidFunction;
}

export function ShipmentsTabs(props: Props) {
  const {
    activeTab,
    partnerShipmentCount,
    publicShipmentCount,
    onTabChange,
    onRefreshClick,
  } = props;

  const handleChange = (
    _event: React.SyntheticEvent,
    newValue: "partner" | "public",
  ) => {
    onTabChange(newValue);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Tabs
          value={activeTab}
          onChange={handleChange}
          aria-label="shipment relation tabs"
        >
          <Tab
            label={`Partner Shipments (${partnerShipmentCount})`}
            value="partner"
            sx={{ fontSize: "1rem", fontWeight: 500 }}
          />
          <Tab
            label={`Public Shipments (${publicShipmentCount})`}
            value="public"
            sx={{ fontSize: "1rem", fontWeight: 500 }}
          />
        </Tabs>
        <Stack direction="row" alignItems="center" spacing={1}>
          <Tooltip title="Lanes are saved filter combinations that let you quickly find shipments matching specific routes, equipment types, and services.">
            <Stack
              direction="row"
              alignItems="center"
              spacing={0.5}
              sx={{ cursor: "pointer" }}
            >
              <IconButton size="small" sx={{ color: "primary.main" }}>
                <HelpOutlineIcon fontSize="small" />
              </IconButton>
              <Typography variant="body2" color="primary.main">
                What are lanes?
              </Typography>
            </Stack>
          </Tooltip>
          {onRefreshClick && (
            <Tooltip title="Refresh shipments">
              <IconButton
                onClick={onRefreshClick}
                size="medium"
                sx={{ color: "primary.main" }}
              >
                <RefreshIcon />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
